import Popper, { PopperPlacementType } from '@mui/material/Popper'

type IDialogProps = {
  dialogContent?: React.ReactNode
  children?: React.ReactNode
  anchorEl: Element | null
  placement?: PopperPlacementType
}

const Popover: React.FC<IDialogProps> = (props) => {
  const { children, anchorEl, dialogContent, placement = 'bottom-start' } = props

  const open = Boolean(anchorEl)

  return (
    <Popper open={open} anchorEl={anchorEl} placement={placement} transition>
      {children || dialogContent}
    </Popper>
  )
}

export default Popover
